module.exports = __webpack_public_path__ + "static/worry02-5812ee67e735beb4048b4ca7650b7798.jpg";